import { Link } from 'react-router-dom';
import { IconArrowLeft, IconCall, IconFillSms } from '@/components/icons/MainIcons';
import Logo from './Logo';
import { FooterLight } from './Lights';
import styles from '@/style/Footer.module.css';
import FooterPanel from './FooterPanel';
import { useTranslation } from 'react-i18next';
import SocialLinks from '@/components/screens/SocialLinks';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <>
            <FooterPanel />
            <footer className={styles.footer}>
                <FooterLight className="ltr:rotate-90 ltr:-translate-x-24" />
                <nav className={`mainContainer ${styles.navWrapper}`}>
                    {/* Logo & Social*/}
                    <div className="space-y-10">
                        <Logo className={`${styles.logo}`} />
                        <SocialLinks className="hidden lg:flex" />
                    </div>
                    {/* Navigation links ( TWO COLUMNS DESKTOP ) ( SINGLE COLUMN MOBILE ) */}
                    <div>
                        <h3 className={styles.linkH3}>{t('footer.content')}</h3>
                        <ul className={styles.ul}>
                            <FooterLink title={t('menu.home')} to="/" />
                            <FooterLink title={t('menu.about')} to="/about" />
                            <FooterLink title={t('menu.projects')} to="/projects" />
                            <FooterLink title={t('footer.partners')} to="/partners" />
                            <FooterLink title={t('footer.contact_us')} to="/contact-us" />
                        </ul>
                    </div>
                    <div className="hidden lg:block">
                        <h3 className={styles.linkH3}>{t('footer.communication')}</h3>
                        <ul className=" space-y-6 text-lg text-Grey80 dark:text-white font-normal">
                            <li className="!mt-0 flex items-center gap-2">
                                <IconFillSms className="filter invert dark:invert-0" />{' '}
                                <span className="dark:text-white text-bg-gray lg:text-[24px] text-[20px] font-medium">
                                    aman@gmail.com
                                </span>
                            </li>
                            <li className="flex items-center gap-2">
                                <IconCall className="filter invert dark:invert-0" />
                                <span
                                    className="dark:text-white text-bg-gray lg:text-[24px] text-[20px] font-medium"
                                    dir="ltr"
                                >
                                    +20 1277 222 849
                                </span>
                            </li>
                        </ul>
                    </div>
                </nav>
                <hr className="mt-10 my-6 bg-Grey20 opacity-15 h-0.5 lg:hidden block" />
                <SocialLinks className="lg:hidden flex justify-evenly items-center mainContainer" />
                <hr className="my-6 bg-Grey20 opacity-15 h-0.5" />
                <div
                    id="privacy-poclicy"
                    className="flex flex-col lg:flex-row items-center justify-center gap-x-6 gap-y-1.5 pb-5"
                >
                    <div className="md:text-[20px] text-lg font-normal dark:text-Grey20 text-bg-gray">
                        {t('footer.contact_us')}
                    </div>
                    <div className="hidden lg:block w-0.5 h-9 bg-Grey20"></div>
                    <div className="flex gap-4 text-[20px] font-normal underline dark:text-Grey20 text-text-bg-gray">
                        <span>{t('footer.Terms_Conditions')}</span>
                        <span>{t('footer.privacy')}</span>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;

const FooterLink = ({ to = '#', title = '---' }: { to: string; title: string }) => (
    <Link to={to}>
        <li>
            <span>{title}</span>
        </li>
        <IconArrowLeft className="dark:text-bg-arrow text-Grey80" />
    </Link>
);
